import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=61ed354b&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ed354b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ed354b')) {
      api.createRecord('61ed354b', component.options)
    } else {
      api.reload('61ed354b', component.options)
    }
    module.hot.accept("./Reports.vue?vue&type=template&id=61ed354b&scoped=true", function () {
      api.rerender('61ed354b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports.vue"
export default component.exports